export default __webpack_public_path__ + "static/media/imageBorderBg.5fd0ffb1.svg";